import { __extends } from "tslib";
import { IndexFacesRequest, IndexFacesResponse } from "../models/index";
import { deserializeAws_json1_1IndexFacesCommand, serializeAws_json1_1IndexFacesCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var IndexFacesCommand = /** @class */ (function (_super) {
    __extends(IndexFacesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function IndexFacesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    IndexFacesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: IndexFacesRequest.filterSensitiveLog,
            outputFilterSensitiveLog: IndexFacesResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    IndexFacesCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1IndexFacesCommand(input, context);
    };
    IndexFacesCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1IndexFacesCommand(output, context);
    };
    return IndexFacesCommand;
}($Command));
export { IndexFacesCommand };
//# sourceMappingURL=IndexFacesCommand.js.map